export const device = {
  tablet: `@media (min-width: 630px)`,
  laptop: `@media (min-width: 900px)`,
  desktop: `@media (min-width: 1200px)`,
  desktopLarge: `@media (min-width: 1800px)`
};